"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toast = void 0;
exports.isLogin = isLogin;
exports.getFegoData = getFegoData;
exports.isApp = isApp;
const webapi_1 = require("@fegobull/webapi");
const tool_browser_1 = require("@futuweb/tool-browser");
var toast_1 = require("./toast");
Object.defineProperty(exports, "toast", { enumerable: true, get: function () { return toast_1.toast; } });
const vue_demi_1 = require("vue-demi");
const { useVariable } = webapi_1.use;
/**
 * 判断是否登录态
 * @returns {boolean}
 */
function isLogin() {
    const FEGODATA = useVariable();
    return !!FEGODATA.UID;
}
function getFegoData() {
    const isRender = (0, vue_demi_1.ref)(!window.FEGOEditor);
    if (isRender.value) {
        const data = useVariable();
        return data;
    }
    return {};
}
function isApp() {
    return (0, tool_browser_1.isMoomoo)() || (0, tool_browser_1.isNN)();
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ1dGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFXQSwwQkFHQztBQUVELGtDQU9DO0FBRUQsc0JBRUM7QUEzQkQsNkNBQXVDO0FBQ3ZDLHdEQUF1RDtBQUN2RCxpQ0FBZ0M7QUFBdkIsOEZBQUEsS0FBSyxPQUFBO0FBQ2QsdUNBQStCO0FBQy9CLE1BQU0sRUFBRSxXQUFXLEVBQUUsR0FBRyxZQUFHLENBQUM7QUFHNUI7OztHQUdHO0FBQ0gsU0FBZ0IsT0FBTztJQUNuQixNQUFNLFFBQVEsR0FBRyxXQUFXLEVBQUUsQ0FBQztJQUMvQixPQUFPLENBQUMsQ0FBQyxRQUFRLENBQUMsR0FBRyxDQUFDO0FBQzFCLENBQUM7QUFFRCxTQUFnQixXQUFXO0lBQ3ZCLE1BQU0sUUFBUSxHQUFHLElBQUEsY0FBRyxFQUFDLENBQUUsTUFBYyxDQUFDLFVBQVUsQ0FBQyxDQUFDO0lBQ2xELElBQUksUUFBUSxDQUFDLEtBQUssRUFBRSxDQUFDO1FBQ2pCLE1BQU0sSUFBSSxHQUFHLFdBQVcsRUFBRSxDQUFDO1FBQzNCLE9BQU8sSUFBSSxDQUFDO0lBQ2hCLENBQUM7SUFDRCxPQUFPLEVBQUUsQ0FBQztBQUNkLENBQUM7QUFFRCxTQUFnQixLQUFLO0lBQ2pCLE9BQU8sSUFBQSx1QkFBUSxHQUFFLElBQUksSUFBQSxtQkFBSSxHQUFFLENBQUM7QUFDaEMsQ0FBQyJ9